import styled from 'styled-components';

export const TimeframeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;
